export const env = {
    environment: process.env.VUE_APP_ENVIRONMENT,
    appName: process.env.VUE_APP_NAME,
    appVersion: process.env.VUE_APP_VERSION,
    appBuild: process.env.VUE_APP_BUILD,
    applicationId: process.env.VUE_APP_APPLICATION_ID,
    apiUrl: process.env.VUE_APP_API_URL,
    apiVersion: "1.0",
    i18nLocale: process.env.VUE_APP_I18N_LOCALE || "en",
    i18nFallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
    appInsights: process.env.VUE_APP_INSIGHTS,
    auth: {
        clientId: process.env.VUE_APP_CLIENTID,
        authority: process.env.VUE_APP_AUTHORITY,
        redirectUri: process.env.VUE_APP_AUTH_REDIRECT_URI,
        consentScopes: process.env.VUE_APP_AUTH_CONSENT_SCOPES,
        apiScopes: process.env.VUE_APP_AUTH_API_SCOPES,
    },
    useMultipleDictionaries: "true" === process.env.VUE_APP_USE_MULTIPLE_DICTIONARIES,
    topLanguages: process.env.VUE_APP_TOPLANGUAGES,
    maxFiles: (process.env.VUE_APP_MAXFILES || 10) as number,
    maxFileMb: (process.env.VUE_APP_MAXFILE_MB || 15) as number,
    maxTotalFilesMb: (process.env.VUE_APP_MAXTOTALFILES_MB || 100) as number,
};
